module.exports = [{
      plugin: require('../node_modules/gatsby-root-component/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
